import { useToast } from '@dc-shared-web/components/shadcn/use-toast'
import { useFSTrackEvent } from '@dc-shared-web/hooks/api/analytic'
import { FS } from '@dc-shared-web/lib/trackingConstants'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

type MoveDocumentParams = {
  folder_uuid: string | null // UUID from project or folder, or null for dashboard
  crunch_uuid: string
  office_uuid: string
  type: 'project' | 'folder' | 'dashboard'
}

type MoveDocumentResponse = {
  data: {
    success: boolean
  }
}

export const moveDocument = async (
  svcCrunchApiClient: AxiosInstance,
  params: MoveDocumentParams
): Promise<MoveDocumentResponse> => {
  const type = params.type === 'dashboard' ? '' : params.type
  const { data } = await svcCrunchApiClient.post<MoveDocumentResponse>(
    `/api/folders/move-crunch?type=${type}`,
    params
  )

  return data
}

export const useMoveDocument = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()
  const { trackEvent } = useFSTrackEvent()

  return useMutation(
    (mutationParams: MoveDocumentParams) =>
      moveDocument(apiClient, mutationParams),
    {
      onSuccess: async (_, context) => {
        trackEvent(FS.DOCUMENT_MOVED)

        await queryClient.invalidateQueries(['folders', 'list'])
        await queryClient.invalidateQueries(['FolderForMove'])
        await queryClient.invalidateQueries(['documents', 'list'])
        await queryClient.invalidateQueries(['projects', 'list'])

        toast({
          variant: 'success',
          title: `Document moved to ${context.type}.`,
        })
        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error moving document',
          description: 'If the issue persists, please contact support.',
        })
        params?.onError?.()
      },
    }
  )
}
